import React from "react";

export const Features = () => {
  const features = [
    {
      icon: "fa fa-exclamation-triangle",
      title: "Incidents",
      text: "Capture the moment when things go wrong—so you can make them right."
    },
    {
      icon: "fa fa-shield",
      title: "Safety",
      text: "Build a culture where safety isn't just a checkbox—it's a cornerstone"
    },
    {
      icon: "fa fa-file-text-o",
      title: "Claims",
      text: "Transform complexity into confidence. Submit, track, and manage claims with precision, ensuring every detail is accounted for and every dollar is justified."
    },
    {
      icon: "fa fa-book",
      title: "Policies",
      text: "Bring order to the backbone of your business. Organize, access, and update policy information effortlessly, so compliance and clarity are always within reach."
    },
    {
      icon: "fa fa-bar-chart",
      title: "Analytics",
      text: "See beyond the data—discover insights that drive smarter decisions."
    },
    {
      icon: "fa fa-line-chart",
      title: "Reporting",
      text: "Turn information into action."
    }
  ];

  return (
    <div id="features" className="section">
      <div className="container">
        <div className="section-title">
          <h2>Features</h2>
          <p>Comprehensive risk management tools designed to keep your business safe and compliant</p>
        </div>
        <div className="row features-grid">
          {features.map((feature, i) => (
            <div key={`${feature.title}-${i}`} className="col-xs-12 col-md-4">
              <div className="feature-card">
                <div>
                  <i className={`${feature.icon} feature-icon`}></i>
                  <h3>{feature.title}</h3>
                </div>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
